import React, { FC, SyntheticEvent, useState } from 'react';
import { useTranslation, Trans } from 'next-i18next';

import styles from './CommunityPhotos.module.scss';

import PhotosGrid from '../../../common/components/PhotosGrid';
import { CommunityPhoto } from '../../../common/types/api/v4/boats/search';
import LazyLightbox from '../../../common/components/Lightbox/LazyLightbox';

export type CommunityPhotosProps = {
  boatHeadline: string;
  communityPhotos: CommunityPhoto[];
  listingId: string;
};

const CommunityPhotos: FC<CommunityPhotosProps> = ({
  boatHeadline,
  communityPhotos,
  listingId,
}) => {
  const [t] = useTranslation('listing-page');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [lightboxStartIndex, setLightboxStartIndex] = useState<number>(0);

  const images = communityPhotos.map(({ url, description }) => ({
    src: url,
    alt: description || boatHeadline,
  }));
  const numberOfPhotos = images.length;

  const openLightbox = (event: SyntheticEvent, index: number) => {
    event.preventDefault();
    setIsOpen(true);
    setLightboxStartIndex(index);
  };

  return numberOfPhotos > 0 && (
    <div className={styles.root}>
      <LazyLightbox
        images={images}
        isOpen={isOpen}
        label={boatHeadline}
        startIndex={lightboxStartIndex}
        closeModal={() => setIsOpen(false)}
      />
      <PhotosGrid
        photos={images.slice(0, 12)}
        openPhoto={openLightbox}
        listingId={listingId}
      />
      <div className={styles.details}>
        <Trans
          t={t}
          i18nKey="community-photos--details"
          count={numberOfPhotos}
          components={[
            // eslint-disable-next-line jsx-a11y/control-has-associated-label
            <button
              type="button"
              onClick={(event) => openLightbox(event, 0)}
              className={styles.button}
            />,
          ]}
        />
      </div>
    </div>
  );
};

export default CommunityPhotos;
